<table class="table table-responsive" *ngIf="liberacoes;else carregando">
    <thead>
        <tr>
            <th scope="col">Nº Liberação de crédito</th>
            <th scope="col">Data da Liberação <span style="color: #b00020;">*</span></th>
            <th scope="col">Valor da Liberação <span style="color: #b00020;">*</span></th>
            <th *ngIf="!modoEdicao && !emInclusao" scope="col" class="text-center">% Desconto ECG <i class="fa fa-question-circle help-subtitulo" placement="bottom"
              ngbTooltip="% de desconto aplicável para redução do valor do encargo conforme legislação vigente ou pessoa com deficiência"></i></th>
            <th *ngIf="!modoEdicao && !emInclusao" scope="col">Valor do ECG</th>
            <th *ngIf="!modoEdicao && !emInclusao" scope="col">Estado</th>
            <th *ngIf="!modoEdicao && !emInclusao" scope="col">Motivo</th>
            <th *ngIf="!modoEdicao && !emInclusao && iope == 0" scope="col">Retificada</th>
        <tr>
    </thead>
    <tbody>
        <tr *ngFor="let liberacao of liberacoes; let i = index">
            <td>
                <span *ngIf="!emInclusao">{{ liberacao?.numero }}</span>
                <span *ngIf="emInclusao">{{ i+1 }}</span>
            </td>
            <td>
                <span *ngIf="!(modoEdicao && modoRetificacao) && !emInclusao">{{ liberacao?.data | date:'dd/MM/yyyy'}}</span>
                <bn-datepicker name="data{{i}}" [(ngModel)]="liberacao.data" *ngIf="(modoEdicao && modoRetificacao) || emInclusao"></bn-datepicker>
            </td>
            <td>
                <span *ngIf="!(modoEdicao && modoRetificacao) && !emInclusao">{{ liberacao?.valor | bnMask:'MOEDA'}}</span>
                <input *ngIf="(modoEdicao && modoRetificacao) || emInclusao"
                    type="text" class="form-control" name="valor{{i}}"
                    [(ngModel)]="liberacao.valor" bnMask="MOEDA"/>
            </td>
            <td *ngIf="!modoEdicao && !emInclusao" class="text-center">{{ (liberacao?.valorRedutorEcg ? liberacao?.valorRedutorEcg : null) | percent: '2.2-4' }}</td>
            <td *ngIf="!modoEdicao && !emInclusao">{{ liberacao?.valorEcg | bnMask:'MOEDA'}}</td>
            <td *ngIf="!modoEdicao && !emInclusao">{{ liberacao?.estadoDTO?.nomeEstado}}</td>
            <td *ngIf="!modoEdicao && !emInclusao">{{ liberacao?.estadoDTO?.motivoEstado}}</td>
            <td *ngIf="!modoEdicao && !emInclusao && iope == 0">{{ liberacao?.retificada == 'S' ? 'Sim' : 'Não'}}</td>
        </tr>
    </tbody>
</table>


<ng-template #carregando>
    <div class="loading-pesquisa">
        <i class="bn-loading"></i>
    </div>
</ng-template>
